import { TagColor } from '@chargify/custom-ui-components';

import { SubscriptionStatus } from '../models';

type Status = { label: string; color: TagColor } | null;

const STATUS_TAG: Record<SubscriptionStatus, Status> = {
  active: null,
  cancellation_scheduled: {
    label: 'Cancelation Scheduled',
    color: 'primary',
  },
  canceled: {
    label: 'Canceled',
    color: 'gray',
  },
  expired: {
    label: 'Expired',
    color: 'gray',
  },
  on_hold: {
    label: 'On Hold',
    color: 'primary',
  },
  past_due: {
    label: 'Past Due',
    color: 'danger',
  },
  trial: {
    label: 'Trial',
    color: 'primary',
  },
  trial_expired: {
    label: 'Trial Ended',
    color: 'gray',
  },
  unpaid: {
    label: 'Unpaid',
    color: 'danger',
  },
  paused: {
    label: 'Paused',
    color: 'primary',
  },
  plan_change_scheduled: {
    label: 'Plan Change Scheduled',
    color: 'primary',
  },
};

export const useSubscriptionStatus = (status: SubscriptionStatus): Status =>
  STATUS_TAG[status];
